export default __webpack_public_path__ + "static/media/FlexibleDiscount-100k.dee6f5b7.png";